<template>
  <v-layout v-if="!$apollo.loading" column class="wrapper">
    <v-flex class="title-screen" xs12>
      <span>Scanned tickets</span>
    </v-flex>
    <v-select
      v-model="selectedEventId"
      :items="performanceDates"
      label="Performance"
      item-text="from"
      item-value="id"
      box
      style="max-width: 1000px"
    />
    <spinner v-if="$apollo.loading" />
    <div v-else>
      <div class="header">
        <div class="headerTitle">Total scanned tickets</div>

        <div class="headerValues">
          <p class="totalValue">
            <span class="scannedValue">{{ totalTicketsScanned }}</span
            >/{{ totalTicketsSold }}
          </p>
        </div>
      </div>
      <div
        v-for="(ticket, index) in tickets"
        :key="index"
        class="pieChart"
        :style="index % 2 == 1 && 'margin-left: 12px'"
      >
        <graph
          :title="ticket.name"
          :data-filter="false"
          :has-data="true"
          :value="`${ticket.scanned}/${ticket.total - ticket.scanned}`"
        >
          <pie-chart
            :data="{
              labels: ['Scanned', 'Not scanned'],
              datasets: [
                {
                  label: 'Ticket data',
                  data: [ticket.scanned, ticket.total - ticket.scanned],
                },
              ],
            }"
            :options="{ displayLegend: true }"
          />
        </graph>
      </div>
    </div>
  </v-layout>
</template>

<script>
import PieChart from '../../components/shared/graphs/pie-chart.vue'
import Graph from '../shared/graphs/graph.vue'
import Spinner from '../shared/spinner.vue'

import { GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import moment from 'moment/moment'
import { GET_EVENT_ENTRY_STATS } from '@/graphql/purchase.graphql'

export default {
  name: 'theater-scanned-tickets-container',
  components: {
    PieChart,
    Graph,
    Spinner,
  },
  props: {
    eventTemplateId: String,
    organizationSlug: String,
  },
  data() {
    return {
      tickets: null,
      totalTicketsScanned: 0,
      totalTicketsSold: 0,
      performanceDates: [],
      selectedEventId: null,
    }
  },
  computed: {
    hasData() {
      return this.tickets.length > 0
    },
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = [
          { id: null, from: 'All performances' },
          ...getEventsByEventTemplateId.map(p => {
            return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
          }),
        ]
      },
    },
    getEventEntryStats: {
      query: GET_EVENT_ENTRY_STATS,
      variables() {
        return {
          eventTemplateId: this.eventTemplateId,
          eventId: this.selectedEventId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventEntryStats: { tickets, totalTicketsScanned, totalTicketsSold },
          } = data
          this.totalTicketsScanned = totalTicketsScanned
          this.totalTicketsSold = totalTicketsSold
          this.tickets = tickets
        }
      },
    },
  },
}
</script>

<style scoped>
.wrapper {
  max-width: 1033px;
}
.pieChart {
  display: inline-block;
  margin-top: 12px;
  width: 48.5%;
}
@media screen and (max-width: 550px) {
  .pieChart {
    width: 100%;
    margin-left: 0 !important;
  }
}
.header {
  width: 48.5%;
  max-height: 133px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 560px) {
  .header {
    width: 100%;
    height: fit-content;
  }
}
.headerTitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #666666;
  margin-left: 24px;
  margin-top: 20px;
  align-self: flex-start;
  margin-right: 24px;
}
.headerValues {
  align-self: flex-start;
  margin-left: 24px;
  font-feature-settings: 'lnum';
}
.scannedValue {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  color: #0277bd;
}
.totalValue {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #979797;
}
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }
}
</style>
